var _path, _g, _g2, _path2, _circle, _path3, _g3, _circle2, _path4, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHubspotTestimonialBackground = function SvgHubspotTestimonialBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 521,
    viewBox: "0 0 1440 521",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.191 58.9238C53.357 67.7103 -164.211 210.941 -246.453 290.993L-259 -12.932L1646.38 -91.5924L1654.14 96.3535C1201.45 380.759 559.485 46.8156 266.191 58.9238Z",
    fill: "url(#HubspotTestimonialBackground_svg__paint0_linear_453_7106)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.61023,
    cy: 8.61023,
    r: 8.61023,
    transform: "matrix(0.987592 -0.157044 -0.157044 -0.987592 991.897 225.299)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.57133,
    cy: 5.57133,
    r: 5.57133,
    transform: "matrix(0.987592 -0.157044 -0.157044 -0.987592 1355.24 252.654)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 5.06484,
    cy: 5.06484,
    r: 5.06484,
    transform: "matrix(0.987592 -0.157044 -0.157044 -0.987592 1240.52 182.687)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.0389,
    cy: 3.0389,
    r: 3.0389,
    transform: "matrix(0.987592 -0.157044 -0.157044 -0.987592 1162.86 145.803)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.0389,
    cy: 3.0389,
    r: 3.0389,
    transform: "matrix(0.987592 -0.157044 -0.157044 -0.987592 1293.73 104.478)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.61023,
    cy: 8.61023,
    r: 8.61023,
    transform: "matrix(0.987592 -0.157044 -0.157044 -0.987592 1138.15 287.174)",
    stroke: "#51A9E3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.55836,
    cy: 4.55836,
    r: 4.55836,
    transform: "matrix(0.987592 -0.157044 -0.157044 -0.987592 963.876 365.147)",
    stroke: "#51A9E3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1422.69 283.944L1420.28 267.788L1435.38 273.67L1422.69 283.944Z",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1020.13 258.934L1010.05 255.616L1017.87 248.566L1020.13 258.934Z",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1065.46 344.038L1055.38 340.721L1063.2 333.67L1065.46 344.038Z",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.407 98.3579L970.623 91.517L986.749 76.9788L991.407 98.3579Z",
    stroke: "#51A9E3",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.67 130.605L1363.34 112.002L1381.5 117.426L1367.67 130.605Z",
    stroke: "#51A9E3",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.67826,
    cy: 5.67826,
    r: 5.67826,
    transform: "matrix(0.987592 -0.157044 -0.157044 -0.987592 647.083 25.4605)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5426,
    cy: 4.5426,
    r: 4.5426,
    transform: "matrix(0.987592 -0.157044 -0.157044 -0.987592 716.736 174.223)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.67826,
    cy: 5.67826,
    r: 5.67826,
    transform: "matrix(0.987592 -0.157044 -0.157044 -0.987592 285.712 88.6741)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.2713,
    cy: 2.2713,
    r: 2.2713,
    transform: "matrix(0.987592 -0.157044 -0.157044 -0.987592 210.725 29.3033)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.81391,
    cy: 6.81391,
    r: 6.81391,
    transform: "matrix(0.987592 -0.157044 -0.157044 -0.987592 569.918 133.174)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.94956,
    cy: 7.94956,
    r: 7.94956,
    transform: "matrix(0.987592 -0.157044 -0.157044 -0.987592 308.912 32.0887)",
    stroke: "#51A9E3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.944 176.962L453.564 159.889L465.015 173.997L446.944 176.962Z",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8802 66.2915L106.062 58.0753L108.128 70.892L95.8802 66.2915Z",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M536.435 199.917L518.765 193.405L533.075 181.387L536.435 199.917Z",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M536.561 30.4891L537.148 5.9655L557.987 18.5441L536.561 30.4891Z",
    stroke: "#51A9E3",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.67826,
    cy: 5.67826,
    r: 5.67826,
    transform: "matrix(-0.985731 -0.16833 -0.16833 0.985731 43.7517 331.745)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.67826,
    cy: 5.67826,
    r: 5.67826,
    transform: "matrix(-0.985731 -0.16833 -0.16833 0.985731 406.287 387.894)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.2713,
    cy: 2.2713,
    r: 2.2713,
    transform: "matrix(-0.985731 -0.16833 -0.16833 0.985731 458.244 468.196)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.81391,
    cy: 6.81391,
    r: 6.81391,
    transform: "matrix(-0.985731 -0.16833 -0.16833 0.985731 151.413 254.507)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.94956,
    cy: 7.94956,
    r: 7.94956,
    transform: "matrix(-0.985731 -0.16833 -0.16833 0.985731 366.15 434.036)",
    stroke: "#51A9E3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.97478,
    cy: 3.97478,
    r: 3.97478,
    transform: "matrix(-0.985731 -0.16833 -0.16833 0.985731 768.032 455.429)",
    stroke: "#51A9E3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.935 252.517L270.185 266.562L263.869 249.524L281.935 252.517Z",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.885 470.037L566.605 474.549L568.763 461.748L578.885 470.037Z",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M204.551 202.047L219.195 213.887L201.785 220.675L204.551 202.047Z",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M150.037 362.465L141.609 385.503L125.911 366.899L150.037 362.465Z",
    stroke: "#51A9E3",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.20588,
    cy: 3.20588,
    r: 3.20588,
    transform: "matrix(0.987592 -0.157044 -0.157044 -0.987592 1316.96 359.475)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 9.61763,
    cy: 9.61763,
    r: 9.61763,
    transform: "matrix(0.987592 -0.157044 -0.157044 -0.987592 1150.23 243.158)",
    stroke: "#51A9E3",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.41175,
    cy: 6.41175,
    r: 6.41175,
    transform: "matrix(0.987592 -0.157044 -0.157044 -0.987592 1286.88 435.674)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.48038,
    cy: 7.48038,
    r: 7.48038,
    transform: "matrix(0.987592 -0.157044 -0.157044 -0.987592 1114.71 434.918)",
    stroke: "#51A9E3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1293.31 309.968L1302.67 295.499L1310.53 310.684L1293.31 309.968Z",
    fill: "#51A9E3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#HubspotTestimonialBackground_svg__filter0_d_453_7106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-246.437 291.387C-164.195 211.335 53.3732 68.1042 266.207 59.3177C559.501 47.2096 1201.47 381.153 1654.16 96.7475",
    stroke: "url(#HubspotTestimonialBackground_svg__paint1_linear_453_7106)",
    strokeWidth: 4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-246.437 291.387C-164.195 211.335 53.3732 68.1042 266.207 59.3177C559.501 47.2096 1201.47 381.153 1654.16 96.7475",
    stroke: "url(#HubspotTestimonialBackground_svg__paint2_linear_453_7106)",
    strokeWidth: 2,
    strokeDasharray: "0.01 6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1336,
    cy: 205,
    r: 24,
    fill: "#FF7A00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "HubspotTestimonialBackground_svg__mask0_453_7106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1323,
    y: 193,
    width: 25,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1348 193H1324V217H1348V193Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#HubspotTestimonialBackground_svg__mask0_453_7106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1344.25 211H1327.75C1327.38 211 1325.5 210.864 1325.5 208.746V208.495H1346.5V208.739C1346.5 209.112 1346.36 210.993 1344.25 210.993M1338.12 215.493H1333.88L1334.39 212.493H1337.61L1338.12 215.493ZM1327.75 194.5H1344.25C1344.63 194.5 1346.51 194.636 1346.51 196.754V207.002H1325.5V204.06L1329.27 200.27L1331.18 202.251C1331.77 202.833 1332.72 202.833 1333.31 202.251L1337.31 198.254C1337.6 197.959 1337.6 197.486 1337.31 197.191C1337.01 196.904 1336.54 196.897 1336.24 197.191L1332.25 201.203L1330.33 199.222C1329.75 198.634 1328.79 198.634 1328.21 199.222L1325.49 201.943V196.754C1325.49 196.38 1325.63 194.5 1327.75 194.5M1344.25 193H1327.75C1324.78 193 1324 195.455 1324 196.754V208.754C1324 211.718 1326.45 212.5 1327.75 212.5H1332.87L1332.37 215.5H1330.75C1330.34 215.5 1330 215.837 1330 216.254C1330 216.67 1330.34 217 1330.75 217H1341.25C1341.67 217 1342.01 216.663 1342.01 216.254C1342.01 215.844 1341.67 215.5 1341.25 215.5H1339.64L1339.14 212.5H1344.25C1347.22 212.5 1348.01 210.045 1348.01 208.746V196.754C1348.01 193.782 1345.55 193 1344.25 193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.5 204.505C1337.5 204.921 1337.84 205.258 1338.25 205.258C1338.66 205.258 1339 204.921 1339 204.505V201.756C1339 201.34 1338.66 201.002 1338.25 201.002C1337.83 201.002 1337.5 201.34 1337.5 201.756V204.505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.25 205.251C1344.67 205.251 1345 204.914 1345 204.505V201.756C1345 201.34 1344.66 201.002 1344.25 201.002C1343.84 201.002 1343.5 201.34 1343.5 201.756V204.505C1343.5 204.921 1343.84 205.251 1344.25 205.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1341.25 205.251C1341.67 205.251 1342 204.914 1342 204.505V199.502C1342 199.086 1341.66 198.749 1341.25 198.749C1340.84 198.749 1340.5 199.086 1340.5 199.502V204.505C1340.5 204.921 1340.84 205.251 1341.25 205.251Z",
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 90,
    r: 24,
    fill: "#6ADDB2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "HubspotTestimonialBackground_svg__mask1_453_7106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 77,
    width: 24,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116 77H92V101H116V77Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#HubspotTestimonialBackground_svg__mask1_453_7106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.004 96.1923C111.996 96.5598 111.851 97.0038 111.208 97.0038H96.8077C96.4402 96.9962 95.9962 96.8507 95.9962 96.2V81.8077C96.0038 81.4402 96.1493 80.9962 96.8 80.9962H111.192C111.56 81.0038 112.004 81.1493 112.004 81.8V96.1923ZM115.204 89.8C115.648 89.8 116 89.4402 116 89.0038C116 88.5675 115.64 88.2 115.204 88.2H113.604V84.1962H115.204C115.648 84.1962 116 83.8364 116 83.3923C116 82.9483 115.64 82.5885 115.204 82.5885H113.604V81.7847C113.604 80.0239 112.172 79.3809 111.2 79.3809H110.396V77.8038C110.404 77.3598 110.044 77 109.6 77C109.156 77 108.796 77.3598 108.796 77.8038V79.4038H104.792V77.8038C104.8 77.3598 104.448 77 104.004 77C103.56 77 103.2 77.3598 103.2 77.8038V79.4038H99.1962V77.8038C99.2038 77.3598 98.844 77 98.4 77C97.956 77 97.5962 77.3598 97.5962 77.8038V79.4038H96.7923C95.0316 79.4038 94.3885 80.8354 94.3885 81.8077V82.6115H92.8038C92.3598 82.6115 92 82.9713 92 83.4153C92 83.8593 92.3598 84.2191 92.8038 84.2191H94.4038V88.223H92.8038C92.3598 88.223 92 88.5828 92 89.0268C92 89.4708 92.3598 89.823 92.8038 89.823H94.4038V93.8268H92.8038C92.3598 93.8268 92 94.1866 92 94.6306C92 95.0746 92.3598 95.4345 92.8038 95.4345H94.4038V96.2383C94.4038 97.999 95.8354 98.6421 96.8077 98.6421H97.6115V100.242C97.6115 100.686 97.9713 101.046 98.4153 101.046C98.8593 101.046 99.2191 100.686 99.2191 100.242V98.6421H103.223V100.242C103.223 100.686 103.583 101.046 104.027 101.046C104.471 101.046 104.831 100.686 104.831 100.242V98.6421H108.834V100.242C108.834 100.686 109.194 101.046 109.638 101.046C110.082 101.046 110.442 100.686 110.442 100.242V98.6421H111.246C113.007 98.6421 113.65 97.2029 113.65 96.2383V95.4345H115.25C115.694 95.4345 116.046 95.0746 116.046 94.6306C116.046 94.1866 115.686 93.8268 115.25 93.8268H113.65V89.823H115.25L115.204 89.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.804 92.9923C108.796 93.3598 108.651 93.8038 108.008 93.8038H100.015C99.6478 93.7962 99.2038 93.6507 99.2038 93V85.0076C99.2114 84.6402 99.3569 84.1962 100.008 84.1962H108C108.367 84.2038 108.811 84.3493 108.811 85V92.9923H108.804ZM108.008 82.6038H100.008C98.2468 82.6038 97.6038 84.0354 97.6038 85.0076V93.0076C97.6038 94.7684 99.043 95.4115 100.008 95.4115H108.008C109.768 95.4115 110.404 93.9799 110.404 93.0076V85.0076C110.404 83.2469 108.972 82.6038 108.008 82.6038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4 90.6038H103.996C103.552 90.6038 103.192 90.9636 103.192 91.4076C103.192 91.8517 103.552 92.2115 103.996 92.2115H106.4C106.844 92.2115 107.196 91.8517 107.196 91.4076C107.196 90.9636 106.836 90.6038 106.4 90.6038Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "HubspotTestimonialBackground_svg__filter0_d_453_7106",
    x: -277.832,
    y: 26.9948,
    width: 1963.05,
    height: 295.826,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.415686 0 0 0 0 0.866667 0 0 0 0 0.698039 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_453_7106"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_453_7106",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HubspotTestimonialBackground_svg__paint0_linear_453_7106",
    x1: 849.776,
    y1: 411.96,
    x2: 822.118,
    y2: -3.27145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F304C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HubspotTestimonialBackground_svg__paint1_linear_453_7106",
    x1: -443.131,
    y1: 193.459,
    x2: 1665.56,
    y2: 106.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#121C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#6ADDB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#121C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HubspotTestimonialBackground_svg__paint2_linear_453_7106",
    x1: -250.783,
    y1: 186.114,
    x2: 1654.6,
    y2: 107.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121C2D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121C2D",
    stopOpacity: 0
  })))));
};
export default SvgHubspotTestimonialBackground;